import { Injectable } from '@angular/core';
import { Service } from '../service';
import { ProfessionalConceptDto } from '../../models/professional-concept/professional-concept-dto';
import { HttpClientService } from '../http-client/http-client.service';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';


@Injectable()
export class ProfessionalConceptService extends Service {


    public professionalConcepts: ProfessionalConceptDto[];
    // public professionalConceptsObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.professionalConcepts = [];
        // this.professionalConceptsObject = {};
    }

    public getAll(schoolYearId: number): Observable<ProfessionalConceptDto[]> {
        // if (!!this.professionalConcepts && this.professionalConcepts.length > 0) {
        //     return Observable.create((observer: Subscriber<ProfessionalConceptDto[]>) => {
        //         observer.next(this.professionalConcepts);
        //         observer.complete();
        //     });
        // }
        const url = 'professionalconcepts/all/' + schoolYearId;
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.professionalConcepts = r.Result;
                // console.log('this.events', this.professionalConcepts);
                // this.professionalConceptsObject = this.professionalConcepts.reduce((result, s) => {
                //     result[String(s.Id)] = result[String(s.Id)] || {};
                //     result[String(s.Id)] = s;
                //     return result;
                // }, {});
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            return this.professionalConcepts;
        }).catch(this.handleError);
    }

    public add(data: any) {
        const url = 'professionalconcepts/add';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/professional-concept/professional-concept.service.ts